module.exports = __webpack_public_path__ + "img/id-card-2.139f73e8.png";